import { useState } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { useAuth } from "../../../hooks/useAuth";
import eventBus from "../../../utils/EventBus";

export default function DamageRequestSendToWarehouseModal({
  requestid,
  tableData = [],
  warehouses = [],
  setShowDamageSendToWarehouseModal,
  refetchRequisition,
}) {
  const { backendUrl } = useAuth();
  const [assignments, setAssignments] = useState({});

  const warehouseOptions = warehouses.filter(
    el => el.value !== "" && el.W_Category === "Stock"
  );

  const sendToWarehouse = async () => {
    let response = await fetch(
      `${backendUrl}/api/requisition/damage/send-to-warehouse`,
      {
        method: "POST",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          requestid,
          items: tableData.map(row => ({
            ...row,
            destinationWarehouse: assignments[row.batchBarCode],
          })),
        }),
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const sendToWarehouseMutation = useMutation(sendToWarehouse, {
    onSuccess: data => {
      toast.success("Items sent to warehouse successfully");
      eventBus.dispatch("REQUISITION_UPDATED", data.requisition);
      setShowDamageSendToWarehouseModal(false);
      if (refetchRequisition) {
        refetchRequisition();
      }
    },
    onError: err => {
      toast.error(`Unable to send to warehouse: ${err?.message || ""}`);
    },
  });

  const handleSubmit = () => {
    const missing = tableData.filter(row => !assignments[row.batchBarCode]);

    if (missing.length > 0) {
      toast.error("Select a destination warehouse for every item");
      return;
    }

    sendToWarehouseMutation.mutate();
  };

  return (
    <Modal
      show={true}
      onHide={() => setShowDamageSendToWarehouseModal(false)}
      centered
      animation={false}
      enforceFocus={false}
      size="lg"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title className="h6 mb-0">Send Items to Warehouse</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table borderless striped className="product-table">
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Batch</th>
              <th>Qty</th>
              <th>Salvage Cost</th>
              <th>Destination Warehouse</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((el, index) => (
              <tr key={`${el.batchBarCode}-${index}`}>
                <td>{el.itemName}</td>
                <td>
                  {el.batchBarCode ? el.batchBarCode.split("-").pop() : "..."}
                </td>
                <td>{el.quantity}</td>
                <td>
                  {el.salvageCost === undefined || el.salvageCost === null
                    ? el.unitCost
                    : el.salvageCost}
                </td>
                <td style={{ minWidth: "220px" }}>
                  <Select
                    classNamePrefix="form-select"
                    menuPosition="fixed"
                    options={warehouseOptions}
                    value={warehouseOptions.find(
                      w => w.value === assignments[el.batchBarCode]
                    )}
                    onChange={selected =>
                      setAssignments(prev => ({
                        ...prev,
                        [el.batchBarCode]: selected?.value,
                      }))
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="white"
          className="border bg-white"
          disabled={sendToWarehouseMutation.isLoading}
          onClick={() => setShowDamageSendToWarehouseModal(false)}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={sendToWarehouseMutation.isLoading}
          onClick={handleSubmit}
        >
          {sendToWarehouseMutation.isLoading ? "Please wait…" : "Send"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
